module.exports = __webpack_public_path__ + "static/media/18.576b7aa3.jpg";